import React from 'react';

const Search = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0327 8.02491C14.0327 6.83822 13.6808 5.67818 13.0215 4.69148C12.3622 3.70479 11.4252 2.93575 10.3288 2.48163C9.23246 2.0275 8.02606 1.90868 6.86218 2.14019C5.69829 2.3717 4.62919 2.94315 3.79008 3.78226C2.95096 4.62138 2.37952 5.69048 2.14801 6.85436C1.91649 8.01825 2.03531 9.22465 2.48944 10.321C2.94357 11.4174 3.7126 12.3544 4.6993 13.0137C5.68599 13.673 6.84603 14.0249 8.03272 14.0249H8.25022H8.49022C9.6053 13.9348 10.673 13.5347 11.5727 12.8699L11.7002 12.7499L14.7002 15.7499L14.7752 15.8174C14.9082 15.9206 15.0719 15.9761 15.2402 15.9749C15.4328 15.9682 15.6154 15.8876 15.7502 15.7499L15.8102 15.6749L15.8627 15.5999C15.9504 15.4559 15.987 15.2865 15.9666 15.1191C15.9462 14.9518 15.8699 14.7961 15.7502 14.6774L12.7502 11.6774L12.8327 11.5724L12.9752 11.3774C13.6545 10.3905 14.0228 9.22292 14.0327 8.02491ZM3.53272 8.02491C3.53272 7.13489 3.79664 6.26486 4.2911 5.52484C4.78557 4.78482 5.48837 4.20804 6.31064 3.86745C7.13291 3.52685 8.03771 3.43774 8.91062 3.61137C9.78354 3.785 10.5854 4.21359 11.2147 4.84292C11.844 5.47226 12.2726 6.27408 12.4463 7.147C12.6199 8.01991 12.5308 8.92471 12.1902 9.74698C11.8496 10.5692 11.2728 11.2721 10.5328 11.7665C9.79276 12.261 8.92273 12.5249 8.03272 12.5249C6.84184 12.5209 5.7011 12.0451 4.86043 11.2016C4.01976 10.3581 3.54771 9.21579 3.54772 8.02491H3.53272Z"
      fill="#6930CA"
    />
  </svg>
);

export default Search;
